import { convertToExportedView } from '@estee/elc-service';
import { PRODUCT_SIZE_PICKER } from '@estee/elc-service-view-names';
import { IProductSizePickerWrapper } from './ProductSizePickerWrapper';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IProductSizePickerWrapper>(
    () => import('./ProductSizePickerWrapper'),
    PRODUCT_SIZE_PICKER
);
